import { defineComponent, shallowRef, computed } from "vue";
import { V as VaColorIndicator } from "../va-color-indicator/index-cd7e8ec1.mjs";
import { V as VaInput } from "../va-input/index-463a53b5.mjs";
import { throttle } from "lodash";
import { u as useStatefulEmits, a as useStatefulProps, b as useStateful } from "../../composables/useStateful-50e4a6b9.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useTranslation } from "../../composables/useTranslation-389ad6ba.mjs";
const _sfc_main = defineComponent({
  name: "VaColorInput",
  components: {
    VaInput,
    VaColorIndicator
  },
  emits: [...useStatefulEmits],
  props: {
    ...useStatefulProps,
    ...useComponentPresetProp,
    modelValue: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    indicator: {
      type: String,
      default: "dot",
      validator: (value) => ["dot", "square"].includes(value)
    },
    ariaOpenColorPickerLabel: { type: String, default: "$t:openColorPicker" }
  },
  setup: (props, { emit }) => {
    const colorPicker = shallowRef();
    const { valueComputed } = useStateful(props, emit);
    const callPickerDialog = () => {
      var _a;
      return !props.disabled && ((_a = colorPicker.value) == null ? void 0 : _a.click());
    };
    const tabIndexComputed = computed(() => props.disabled ? -1 : 0);
    const inputValue = computed({
      get: () => props.modelValue,
      set: throttle((value) => emit("update:modelValue", value), 500)
    });
    return {
      ...useTranslation(),
      valueComputed,
      inputValue,
      callPickerDialog,
      colorPicker,
      tabIndexComputed
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaColorInput.css';
//# sourceMappingURL=VaColorInput.vue_vue_type_script_lang-dd59b887.mjs.map
